import React, { useContext } from 'react';
import './styles.css';
import P from 'prop-types';
import { GlobalContext } from '../../contexts/HomeContext';
import { RemoveUser } from '../../utils/utils';
import { Button } from '../Button';
import { Image } from '../Image';
import chevronRightSVG from '../../img/chevron_right.svg';
import infoSVG from '../../img/info.svg';
import areaSVG from '../../img/area.svg';
import pagamentoSVG from '../../img/pagamento.svg';
import entrarSVG from '../../img/entrar.svg';
import ajudaSVG from '../../img/ajuda.svg';
import userSVG from '../../img/user.svg';
import pedidosSVG from '../../img/pedidos.svg';
import sairSVG from '../../img/sair.svg';
import enderecosPNG from '../../img/enderecos.png';
import cartoesPNG from '../../img/meus_cartoes.png';

export const Menu = ({ handleModal, handleClose }) => {
  const { dadosApp, user, setUser, setEnderecos } = useContext(GlobalContext);

  const handleLogout = () => {
    RemoveUser(dadosApp.IdLoja, setUser, setEnderecos);
    handleClose();
  };

  return (
    <div>
      {user.id > 0 && (
        <>
          {!user.email.includes('pedido_') && user.nome !== 'CLIENTE' && (
            <div className="btn-menu" onClick={() => handleModal('MEUS_DADOS', 'Meus Dados')}>
              <Image srcLocal={userSVG} alt="usuario" />
              <Button text="Meus Dados" textAlign="left" />
              <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
            </div>
          )}
          {dadosApp.TipoApp === 'DELIVERY' && (
            <div className="btn-menu" onClick={() => handleModal('ENDERECOS', 'Endereços')}>
              <Image srcLocal={enderecosPNG} alt="enderecos" className="menu-icons" />
              <Button text="Endereços" textAlign="left" />
              <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
            </div>
          )}
          {dadosApp.Empresa.Config.pagamento_online === 1 &&
            !user.email.includes('pedido_') &&
            user.nome !== 'CLIENTE' && (
              <div className="btn-menu" onClick={() => handleModal('LISTA_CARTOES', 'Cartões')}>
                <Image srcLocal={cartoesPNG} alt="cartoes" className="menu-icons" />
                <Button text="Cartões" textAlign="left" />
                <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
              </div>
            )}
          <div className="btn-menu" onClick={() => handleModal('PEDIDOS', 'Pedidos')}>
            <Image srcLocal={pedidosSVG} alt="pedidos" />
            <Button text="Pedidos" textAlign="left" />
            <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
          </div>
        </>
      )}

      {dadosApp.TipoApp === 'DELIVERY' && (
        <>
          <div className="btn-menu">
            <Image srcLocal={infoSVG} alt="info" />
            <Button
              text="Informações"
              textAlign="left"
              onClick={() =>
                handleModal(
                  'INFORMACOES',
                  dadosApp.Empresa.Empresa.fantasia_edicao != ''
                    ? dadosApp.Empresa.Empresa.fantasia_edicao
                    : dadosApp.Empresa.Empresa.fantasia,
                )
              }
            />
            <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
          </div>

          <div className="btn-menu">
            <Image srcLocal={areaSVG} alt="area" />
            <Button
              text="Área de Atendimento"
              textAlign="left"
              onClick={() => handleModal('AREA_ATENDIMENTO', 'Área de Atendimento')}
            />
            <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
          </div>

          <div className="btn-menu">
            <Image srcLocal={pagamentoSVG} alt="pagamento" />
            <Button
              text="Meios de pagamento"
              textAlign="left"
              onClick={() => handleModal('INFO_PAGAMENTO', 'Meios Pagamento')}
            />
            <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
          </div>

          <div className="btn-menu">
            <Image srcLocal={ajudaSVG} alt="ajuda" />
            <Button text="Ajuda" textAlign="left" onClick={() => handleModal('AJUDA', 'Ajuda')} />
            <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
          </div>
        </>
      )}

      {user.id <= 0 && (
        <div className="btn-menu">
          <Image srcLocal={entrarSVG} alt="entrar" />
          <Button text="Entrar ou Cadastrar" textAlign="left" onClick={() => handleModal('LOGIN', 'Login')} />
          <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
        </div>
      )}

      {user.id > 0 && (
        <div className="btn-menu">
          <Image srcLocal={sairSVG} alt="sair" />
          <Button text="Sair" textAlign="left" onClick={handleLogout} />
          <Image srcLocal={chevronRightSVG} className="rotate90" alt="chevron" />
        </div>
      )}
    </div>
  );
};

Menu.propTypes = {
  handleModal: P.func,
  handleClose: P.func,
};
